/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4"

/**
 * @description A protected symmetric key is one that is base64 encoded and contains the initialization vector and the ciphertext
 */
export const protectedSymmetricKeySchema = z
  .string()
  .describe(
    "A protected symmetric key is one that is base64 encoded and contains the initialization vector and the ciphertext",
  )
